import { Mesa, TipoOrden } from "src/gql/schema"
import { FilterMenuItem, FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import './header.css'
import IconInfo from "src/shared/icons/infoToolTip"
import Tooltip from "src/shared/components/data-display/tooltip/Tooltip"
import { Placement } from "@floating-ui/react"

export const TooltipInfo = ({ title = "", description = "", placement = "top" }:
    { title?: string, description?: string, placement?: Placement }
) => {
    return (
        <Tooltip title={title} description={description} theme={"dark"} placement={placement}>
            <IconInfo />
        </Tooltip>
    )
}


const EnPreparacion = () => <div className="historial-rs-table__header__cell-container">
    <span className="historial-rs-table__header__cell-text">En preparación</span>
    <TooltipInfo
        placement="top-start"
        description="Tiempo desde que se registra la orden hasta que se finaliza la preparación del último producto."
        title="En preparación"
    />
</div>

const TiempoTotal = () => <div className="historial-rs-table__header__cell-container">
    <span className="historial-rs-table__header__cell-text">Tiempo total</span>
    <TooltipInfo
        placement="top-start"
        title="Tiempo total"
        description="Duración completa de la orden, desde que se crea hasta que se registra el pago."
    />
</div>

const EnEntrega = () => <div className="historial-rs-table__header__cell-container">
    <span className="historial-rs-table__header__cell-text">En entrega</span>
    <TooltipInfo
        placement="top-start"
        title="En entrega"
        description="Tiempo desde que el mesero libera la orden hasta el registro del pago. Disponible únicamente cuando la orden está en pendiente de pago."
    />
</div>

const PorEntregar = () => <div className="historial-rs-table__header__cell-container">
    <span className="historial-rs-table__header__cell-text">Por entregar</span>
    <TooltipInfo
        placement="top-start"
        description="Tiempo desde que el primer producto está listo hasta que el último pasa a estado “Por entregar”."
        title="Por entregar"
    />
</div>

const getHeadersMostrador = (): FlexibleTableHeaderColumn[] => {
    const headers = [
        {
            value: "Orden",
        },
        {
            value: "Turno",
        },
        {
            value: "Fecha y hora de venta",
        },
        {
            value: "Responsable",
        },
        {
            value: "Total",
        },
        {
            value: "Método de pago",
        },
        {
            value: "En preparación",
            valueToDisplay: <EnPreparacion />
        },
        {
            value: "Por entregar",
            valueToDisplay: <PorEntregar />
        },
        {
            value: "En entrega",
            valueToDisplay: <EnEntrega />
        },
        {
            value: "Tiempo total",
            valueToDisplay: <TiempoTotal />
        },
        {
            value: "Estatus",
        },
    ]
    return headers
}

const getHeadersRestaurant = (filterMenu: FilterMenuItem[]): FlexibleTableHeaderColumn[] => {
    const headers = [
        {
            value: "Orden",
        },
        {
            value: "Comanda",
        },
        {
            value: "Mesa",
            filterMenu,
        },
        {
            value: "Turno y hora de venta",
        },
        {
            value: "Responsable",
        },
        {
            value: "Total",
        },
        {
            value: "Método de pago",
        },
        {
            value: "En preparación",
            valueToDisplay: <EnPreparacion />
        },
        {
            value: "Por entregar",
            valueToDisplay: <PorEntregar />
        },
        {
            value: "Tiempo total",
            valueToDisplay: <TiempoTotal />
        },
        {
            value: "Estatus",
        },
    ]
    return headers
}
const getHeadersRoomService = (): FlexibleTableHeaderColumn[] => {
    const headers = [
        {
            value: "Orden",
        },
        {
            value: "Turno",
        },
        {
            value: "Fecha y hora de venta",
        },
        {
            value: "Responsable",
        },
        {
            value: "Origen",
        },
        {
            value: "Total",
        },
        {
            value: "Método de pago",
        },
        {
            value: "En preparación",
            valueToDisplay: <EnPreparacion />
        },
        {
            value: "Por entregar",
            valueToDisplay: <PorEntregar />
        },
        {
            value: "En entrega",
            valueToDisplay: <EnEntrega />
        },
        {
            value: "Tiempo total",
            valueToDisplay: <TiempoTotal />
        },
        {
            value: "Estatus",
        },
    ]
    return headers
}

const ITEM_ALL = { value: "todos", valueToDisplay: "Todos" }


export function useHeader(data: Mesa[], tipo: TipoOrden): FlexibleTableHeaderColumn[] {
    const mesaNumbers = Array.from(new Set(data.map((item) => item.numero_mesa)))
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

    const mesaFilter = [
        ITEM_ALL,
        ...mesaNumbers.map((numero) => ({
            value: numero,
            valueToDisplay: `Mesa ${numero}`,
        })),
    ];

    if (tipo === TipoOrden.RoomService) {
        return getHeadersRoomService()
    }
    if (tipo === TipoOrden.Restaurante) {
        return getHeadersRestaurant(mesaFilter)
    }
    // Mostrador 
    return getHeadersMostrador()
}
